import { useMutation } from '@tanstack/react-query';

import { ApiError } from '@/shared/api/ApiError';
import { submitMaxPersonal2fa } from '@/shared/api/channels/maxPersonal';
import { useNotifications } from '@/shared/ui/Notifications';

export function useMaxPersonal2fa() {
  const { addNotification } = useNotifications();

  const mutation = useMutation<
    void,
    ApiError,
    { channelId: string; password: string }
  >({
    mutationFn: ({ channelId, password }) =>
      submitMaxPersonal2fa(channelId, password),
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  return {
    submit: (channelId: string, password: string) =>
      mutation.mutateAsync({ channelId, password }),
    isPending: mutation.isPending,
  };
}
